import { render, staticRenderFns } from "./BudgetGoalCard.vue?vue&type=template&id=3efc5a73"
import script from "./BudgetGoalCard.vue?vue&type=script&lang=js"
export * from "./BudgetGoalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports